module.exports = __webpack_public_path__ + "static/media/member_placeholder.9e77c19a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member_placeholder.svg
// module id = 455
// module chunks = 1